import Api from "./api";

class SerpApi {
    api = new Api();

    /**
     * Создание нового проекта задания на парсинг выдачи
     */
    createProject(data = {name: null, regionId: null, words: [], topNumber: null, searchEngine: null}) {
        return this.api.post('serp', {data: data});
    }

    /**
     * Обновление данных проекта
     * @param {Number} projectId
     * @param data {{
     *     scrape_ai_answers: Boolean,
     * }}
     */
    updateProject(projectId, data) {
        return this.api.post('serp/' + projectId + '/update', data);
    }

    /**
     * Удаление проекта
     */
    deleteProject(projectId = null) {
        return this.api.delete('serp/' + projectId);
    }

    /**
     * Переименование проекта
     */
    updateProjectName(projectId = null, data = {name: null}) {
        return this.api.patch('serp/' + projectId + '/project-name', data);
    }

    /**
     * Получаем данные готовых проектов
     * @param {String} projectsIds - список ID проектов через запятую
     * @return {Promise<{
     *     id: Number,
     *     base: Number,
     *     name: String,
     *     status: String,
     *     error_msg: String|null,
     *     progress: Number,
     *     created_at: String
     *     updated_at: String,
     *     words_count: Number,
     *     search_engine: String,
     *     cluster_uid: String,
     *     cluster_name: String,
     *     monitoring_id: Number,
     *     monitoring_name: String,
     * }[] | []>}
     */
    getProjectsCompleted(projectsIds) {
        return this.api.get('serp/projects-completed', {ids: projectsIds});
    }

    /**
     * Проверка статуса съёма проекта
     * @param {Number} projectId
     * @return {Promise<{
     *     status: String,
     *     error_msg: String|null,
     *     progress: Number,
     * }>}
     */
    getProjectStatus(projectId) {
        return this.api.get('serp/' + projectId + '/status');
    }

    /**
     * Получаем список проектов
     * @param data{{
     *     sort: String,
     *     page: Number,
     *     per_page: Number,
     *     isMain?: Boolean,
     * }}
     * @return {Promise<{
     *     id: Number,
     *     base: Number,
     *     name: String,
     *     status: String,
     *     error_msg: String|null,
     *     progress: Number,
     *     created_at: String
     *     updated_at: String,
     *     words_count: Number,
     *     search_engine: String,
     *     cluster_uid: String,
     *     cluster_name: String,
     *     monitoring_id: Number,
     *     monitoring_name: String,
     * }[] | []>}
     */
    getProjectsList(data) {
        return this.api.get('serp', data);
    }

    /**
     * Получаем данные проекта
     * @param projectId
     * @param data
     * @returns {Promise<{
     *     (word): {
     *          contextHash: String,
     *          description: String,
     *          domain: String,
     *          errors: String,
     *          legal: String,
     *          pos: Number,
     *          siteLinks: {
     *              did: Number,
     *              domain: String,
     *              text: String,
     *              url: String
     *          }[],
     *          subType: String,
     *          title: String,
     *          type: String,
     *          url: String,
     *          word: String,
     *     }[]
     * }>}
     */
    getProjectData(projectId, data = {searchEngine: null, organic: null, context: null, wizard: null, word: null, limit: null, ver: null}) {
        return this.api.get('serp/' + projectId, data);
    }

    /**
     * Получаем версии (даты съёмов) проекта, от новых к старым
     * @param {Number} projectId
     * @returns {Promise<String[]>}
     */
    getProjectVersions(projectId) {
        return this.api.get('serp/' + projectId + '/versions');
    }

    /**
     * Получаем данные доменов конкурентов проекта
     * @param projectId
     * @param data
     * @returns {Promise<{
     *     total: Number,
     *     data: {
     *         cnt: Number,
     *         did: Number,
     *         domain: String
     *     }[]
     * }>}
     */
    getProjectCompetitorDomains(projectId, data = {page: null, per_page: null, organic: true, context: true}) {
        return this.api.get('serp/' + projectId + '/competitor-domains', data);
    }

    /**
     * Получаем данные ссылок конкурентов проекта
     * @param {Number} projectId
     * @param data{{
     *     page?: Number,
     *     per_page?: Number,
     *     organic: Boolean,
     *     context: Boolean,
     *     paramsGET: Boolean,
     * }}
     * @returns {Promise<{
     *     total: Number,
     *     data: {
     *         cnt: Number,
     *         did: Number,
     *         domain: String,
     *         url: String,
     *         full_url: String
     *     }[]
     * }>}
     */
    getProjectCompetitorPages(projectId, data = {page: null, per_page: null}) {
        return this.api.get('serp/' + projectId + '/competitor-pages', data);
    }

    /**
     * Получаем данные для экспорта
     * @param projectId
     * @param data
     * @returns {Promise<{
     *      contextHash: String,
     *      description: String,
     *      domain: String,
     *      errors: String,
     *      legal: String,
     *      pos: Number,
     *      siteLinks: {
     *          did: Number,
     *          domain: String,
     *          text: String,
     *          url: String
     *      }[],
     *      subType: String,
     *      title: String,
     *      type: String,
     *      url: String,
     *      word: String,
     * }[]>}
     */
    getExportData(projectId, data = {searchEngine: null, organic: null, context: null, wizard: null, word: null, limit: null, ver: null}) {
        return this.api.get('serp/' + projectId + '/csv', data);
    }

    /**
     * Получаем статус фоновой CSV выгрузки.
     * @param {Number} projectId
     * @param {String} jobId
     * @returns {Promise<{status: string, downloadUrl?: string, error?: string}>}
     */
    getExportStatus(projectId, jobId) {
        return this.api.get('serp/' + projectId + '/csv/export-status', {job_id: jobId});
    }
}

export default new SerpApi;
